import React, { ChangeEvent, FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
import { typographyPxSizes, typographyRemSizes, withTheme } from '@shared/lib/theme';
import Text from './Text';
export interface CustomTextAreaProps extends Omit<HTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
}
const TextArea: FC<CustomTextAreaProps> = ({
  value,
  onChange,
  error,
  ...props
}) => {
  const isError = Boolean(error);
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e.target.value);
  };
  return <>
      <TextAreaWrapper value={value} onChange={handleChange} isError={isError} {...props} />
      {error && <BottomTextWrapper>
          <Text family="MTSCompact" size="pS" weight="medium" color="negative">
            {error}
          </Text>
        </BottomTextWrapper>}
    </>;
};
export default TextArea;
interface TextAreaWrapperProps {
  isError: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isError,
  theme
}) => `0.125rem solid ${isError ? theme.colors.stroke.error : 'transparent'}`;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.stroke.default;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.family.MTSCompact;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.weight.regular;
const _exp5 = /*#__PURE__*/() => () => typographyRemSizes.size.pS;
const _exp6 = /*#__PURE__*/() => () => typographyRemSizes.lineHeight.pS;
const _exp7 = /*#__PURE__*/() => () => typographyRemSizes.letterSpacing.pS;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.stroke.hover;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.stroke.active;
const _exp10 = /*#__PURE__*/() => ({
  isError,
  theme
}) => `1px solid ${isError ? theme.colors.stroke.error : 'transparent'}`;
const _exp11 = /*#__PURE__*/() => () => typographyPxSizes.size.pS;
const _exp12 = /*#__PURE__*/() => () => typographyPxSizes.lineHeight.pS;
const _exp13 = /*#__PURE__*/() => () => typographyPxSizes.letterSpacing.pS;
const TextAreaWrapper = withTheme(/*#__PURE__*/styled('textarea')({
  name: "TextAreaWrapper",
  class: "tqf4ubf",
  propsAsIs: false,
  vars: {
    "tqf4ubf-0": [_exp()],
    "tqf4ubf-1": [_exp2()],
    "tqf4ubf-2": [_exp3()],
    "tqf4ubf-3": [_exp4()],
    "tqf4ubf-4": [_exp5()],
    "tqf4ubf-5": [_exp6()],
    "tqf4ubf-6": [_exp7()],
    "tqf4ubf-7": [_exp8()],
    "tqf4ubf-8": [_exp0()],
    "tqf4ubf-9": [_exp1()],
    "tqf4ubf-10": [_exp10()],
    "tqf4ubf-11": [_exp11()],
    "tqf4ubf-12": [_exp12()],
    "tqf4ubf-13": [_exp13()]
  }
}));
const BottomTextWrapper = /*#__PURE__*/styled('div')({
  name: "BottomTextWrapper",
  class: "bywrg5s",
  propsAsIs: false
});

require("./TextArea.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TextArea.tsx");